<template>
  <section
    data-test-id="UserGroupResource"
  >
    <div :class="$style.resourceHeading">
      <HeadingExtraSmall
        :hasMargin="false"
      >
        {{ config.heading }}
      </HeadingExtraSmall>
      <HeadingExtraSmall
        v-if="showResourceCount"
        :class="$style.additionalItems"
        data-test-id="DevicesList__devicesAdditionalItems"
        :hasMargin="false"
        weight="light"
      >
        {{ resourcesCountText }}
      </HeadingExtraSmall>
    </div>
    <LoadingIcon
      v-if="isLoading"
      :scale="1.75"
    />
    <ParagraphBody
      v-else-if="resourceData"
    >
      {{ resourceData }}
    </ParagraphBody>
    <ParagraphBody
      v-else
    >
      {{ config.zeroStateText }}
      <Link
        :href="config.route"
        :text="config.linkText"
      />
    </ParagraphBody>
  </section>
</template>

<script>
import {
  HeadingExtraSmall,
  Link,
  LoadingIcon,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'UserGroupResource',

  components: {
    Link,
    LoadingIcon,
    HeadingExtraSmall,
    ParagraphBody,
  },

  props: {
    config: {
      type: Object,
      default: () => {},
    },

    isLoading: Boolean,

    resourceData: {
      type: String,
      default: '',
    },

    totalCount: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    resourcesCountText() {
      return `Showing first 100 of ${this.totalCount} items`;
    },

    showResourceCount() {
      return this.totalCount > 100;
    },
  },
};
</script>

<style module scoped>
.linkText.linkText {
  text-transform: none;
}

.resourceHeading {
  display: flex;
}

.additionalItems {
  padding-left: var(--jc-spacer-small);
}
</style>
